const problems = [
  {
    icon: 'ri-arrow-up-down-line',
    title: 'Leads Come and Go',
    desc: 'One month you\'re busy, the next you\'re slow. There\'s no predictable system bringing customers in.',
  },
  {
    icon: 'ri-user-shared-line',
    title: 'Referrals Aren\'t Reliable',
    desc: 'Word-of-mouth is great — until it dries up. You can\'t scale a business on hope and handshakes.',
  },
  {
    icon: 'ri-search-line',
    title: 'Competitors Show Up First',
    desc: 'When customers search Google, your competitors appear before you. That means they\'re getting your customers.',
  },
  {
    icon: 'ri-money-dollar-circle-line',
    title: 'Marketing Spend Goes to Waste',
    desc: 'You\'ve tried ads or agencies before and got nothing. Money out, no results in. That ends here.',
  },
];

const ProblemSection = () => (
  <section id="problem" className="bg-[#0a1628] py-24 md:py-32">
    <div className="max-w-6xl mx-auto px-6 md:px-10">
      <div className="mb-12">
        <span className="inline-block bg-white/10 text-white/70 text-xs font-semibold uppercase tracking-widest px-4 py-2 rounded-full mb-6">
          The Challenge
        </span>
        <h2 className="text-3xl md:text-5xl font-extrabold text-white leading-tight max-w-2xl">
          Most businesses struggle to get <span className="text-orange-400">consistent customers.</span>
        </h2>
        <p className="text-white/60 text-lg mt-4 max-w-xl">
          Sound familiar? You're not alone — and it's not your fault. The system is broken. We fix it.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        {problems.map((p) => (
          <div
            key={p.title}
            className="group border border-white/10 hover:border-orange-500/50 rounded-2xl p-8 transition-all duration-300 bg-white/5 hover:bg-white/8"
          >
            <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-orange-500/15 mb-5">
              <i className={`${p.icon} text-orange-400 text-2xl`} />
            </div>
            <h3 className="text-white font-bold text-xl mb-3">{p.title}</h3>
            <p className="text-white/60 text-base leading-relaxed">{p.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default ProblemSection;
